module.exports = __webpack_public_path__ + "static/media/avatar-single.47111bdc.svg";